import {
  INICIA_SERIE,
  SALVA_SERIE,
  REMOVE_SERIE,
  NOVO_SERIE,
  BUSCA_SERIE_EDICAO,
  INICIO_SERIE_SUCESSO,
  SALVA_SERIE_SUCESSO,
  REMOVE_SERIE_SUCESSO,
  BUSCA_SERIE_EDICAO_SUCESSO,
  ATUALIZA_SERIE,
  ON_SHOW_LOADER,
  ON_SHOW_SUCCESS_MESSAGE,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  LISTA_SERIE,
  LISTA_SERIE_SUCESSO,
  LIMPAR_SERIE,
  LISTA_ESCOLAS_SERIE,
  LISTA_ESCOLAS_SERIE_SUCESSO,
  LISTA_CURSOS_POR_ESCOLA_SERIE,
  LISTA_CURSOS_POR_ESCOLA_SERIE_SUCESSO,
  APLICA_FILTRO_SERIE
} from 'constants/ActionTypes';

/*#############################################################################################*/
/* ------------------------------ Actions Fundamentais CRUD -----------------------------------*/

export const onChangeFilterSerie = (e) => {
  return {
      type: APLICA_FILTRO_SERIE,
      payload: e.target.value
  }
};

export const iniciaSerie = () => {
  return {
    type: INICIA_SERIE
  };
};

export const salvaSerie = (serie) => {
  return {
    type: SALVA_SERIE,
    payload: serie
  };
};

// Opcional: ação explícita para atualizar série (se quisermos separar do SALVA)
export const atualizaSerie = (serie) => {
  return {
    type: ATUALIZA_SERIE,
    payload: serie
  };
};

export const removeSerie = (id) => {
  return {
    type: REMOVE_SERIE,
    payload: id
  };
};

export const listaSerie = (filtros) => {
  let payload = {};
  if (typeof filtros === 'string') {
    payload = { nome: filtros };
  } else {
    payload = filtros || {};
  }

  return {
    type: LISTA_SERIE,
    payload
  };
};

export const listaEscolasSerie = () => ({ type: LISTA_ESCOLAS_SERIE });
export const listaEscolasSerieSucesso = (escolas) => ({ type: LISTA_ESCOLAS_SERIE_SUCESSO, payload: escolas });

export const listaCursosPorEscolaSerie = (escolaId) => ({ type: LISTA_CURSOS_POR_ESCOLA_SERIE, payload: escolaId });
export const listaCursosPorEscolaSerieSucesso = (cursos) => ({ type: LISTA_CURSOS_POR_ESCOLA_SERIE_SUCESSO, payload: cursos });


/*#############################################################################################*/
/* ---------------------------- Actions do Fluxo de Navegação ---------------------------------*/

export const novoSerie = () => {
  return {
    type: NOVO_SERIE
  };
};

export const buscaSerieEdicao = (id) => {
  return {
    type: BUSCA_SERIE_EDICAO,
    payload: id
  };
};

/*#############################################################################################*/
/* --------------------------- Actions de respostas actions anteriores ------------------------*/  

export const inicioSerieSucesso = (serie) => {
  return {
    type: INICIO_SERIE_SUCESSO,
    payload: serie
  }
};

export const salvaSerieSucesso = (mensagem) => {
  return {
    type: SALVA_SERIE_SUCESSO,
    payload: mensagem
  }
};

export const removeSerieSucesso = (mensagem) => {
  return {
    type: REMOVE_SERIE_SUCESSO,
    payload: mensagem
  }
};  

export const buscaSerieEdicaoSucesso = (serie) => {
  return {
    type: BUSCA_SERIE_EDICAO_SUCESSO,
    payload: serie
  };
}; 

export const listaSerieSucesso = (serie) => {
  return {
    type: LISTA_SERIE_SUCESSO,
    payload: { serie }
  };
};

export const limparFiltroSerie = () => {
  return {
    type: LIMPAR_SERIE,
  };
};

/*#############################################################################################*/
/* ---------------------------------- Outras Actions Auxiliares -------------------------------*/ 

export const exibirMensagemErro = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showAuthLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideMessage = () => {
  return {
    type: HIDE_MESSAGE,
  };
};

export const showAuthMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message
  };
};

export const showSuccessMessage = (message) => {
  return {
    type: ON_SHOW_SUCCESS_MESSAGE,
    payload: message
  };
};